import React from 'react'
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContentText,
  FormControlLabel,
  TextField,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import ButtonSubmit from '../../common/ButtonSubmit'
import DialogContent from './DialogContent'
import { PROGRAM_DIALOG_HEIGHT } from './programUtils'

const StepProgramDetails = ({
  isPaymentMethodRequired,
  onBack,
  values,
  handleChange,
  setFieldValue,
  handleBlur,
  touched,
  errors,
  submitting,
  error,
}) => {
  const helperText =
    'Your subsidy name is for internal use only and will not be viewable by your team.'
  const toggleEndDate = isChecked => {
    setFieldValue('endDateRequested', isChecked)
    setFieldValue('endDate', '')
  }

  return (
    <>
      <DialogContent height={PROGRAM_DIALOG_HEIGHT}>
        <DialogContentText>What do you want to name your subsidy?</DialogContentText>
        <TextField
          autoFocus
          fullWidth
          id="name"
          name="name"
          variant="outlined"
          label="Subsidy Name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.name && Boolean(errors.name)}
          helperText={(touched.name && errors.name) || helperText}
        />
        <Box paddingY={4}>
          <DialogContentText>When would you like your subsidy to start?</DialogContentText>
          <TextField
            fullWidth
            id="startDate"
            type="date"
            defaultValue={values.startDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.startDate && Boolean(errors.startDate)}
            helperText={touched.startDate && errors.startDate}
          />
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.endDateRequested}
              onChange={event => toggleEndDate(event.target.checked)}
              name="setEnd"
            />
          }
          label="Set an end date?"
        />
        {values.endDateRequested && (
          <TextField
            autoFocus={values.endDateRequested}
            fullWidth
            id="endDate"
            type="date"
            defaultValue={values.endDate}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.endDate && Boolean(errors.endDate)}
            helperText={touched.endDate && errors.endDate}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack}>Back</Button>
        <ButtonSubmit color="primary" variant="contained" submitting={submitting}>
          {isPaymentMethodRequired ? 'Next' : 'Create'}
        </ButtonSubmit>
      </DialogActions>
      {error && <Alert color="error">{error}</Alert>}
    </>
  )
}

export default StepProgramDetails
